import { GrowthBook, GrowthBookProvider } from '@growthbook/growthbook-react';
import { trackExperiment } from '@/lib/analytics';
import { PropsWithChildren, useEffect } from 'react';

const growthBook = new GrowthBook({
  apiHost: process.env.NEXT_PUBLIC_GROWTHBOOK_API_HOST,
  clientKey: process.env.NEXT_PUBLIC_GROWTHBOOK_CLIENT_KEY,
  enableDevMode: process.env.NEXT_PUBLIC_GROWTHBOOK_DEV_MODE === 'true',
  trackingCallback: (experiment, result) => {
    console.log('Experiment viewed', experiment.key, result);
    trackExperiment(experiment.key, result);
  },
});

export default function Growthbook({ children }: PropsWithChildren) {
  useEffect(() => {
    growthBook.init({ streaming: true });
  }, []);

  useEffect(() => {
    // Get existing ID from localStorage or generate a new one
    const getOrCreateUserId = () => {
      const storageKey = 'growthbook-user-id';
      const existingId = localStorage.getItem(storageKey);

      if (existingId) {
        return existingId;
      }

      // Generate a random ID if none exists
      const newId = Math.random().toString(36).substring(2, 15);
      localStorage.setItem(storageKey, newId);
      return newId;
    };

    growthBook.setAttributes({
      id: getOrCreateUserId(),
    });
  }, []);

  return (
    <GrowthBookProvider growthbook={growthBook}>{children}</GrowthBookProvider>
  );
}
